export const SET_ENTITIES = 'SET_ENTITIES' as const
